import { request } from "./client";

/**
 * "Going" / "Not going" from the buttons in reminder emails. No login: the token in the link identifies one
 * player's registration for one game.
 *
 * Both return { firstName, leagueName, startsAt, whenText, venue, rsvp: "YES" | "NO" | "NO_RESPONSE",
 * state: "open" | "started" | "cancelled" }.
 */

/** Shows the game and the current answer. Changes nothing. */
export const getRsvp = async (token) => request(`/rsvp/${encodeURIComponent(token)}`);

/** Records the answer. `response` is "YES" (going) or "NO" (not going). */
export const answerRsvp = async (token, response) =>
  request(`/rsvp/${encodeURIComponent(token)}`, { method: "POST", body: JSON.stringify({ response }) });
